// 行政管理下面的接口

import request from "@/utils/request";


/***** minica 杭州博乐 admin add start ****/

// 年级删除 
export function gradeDelete(data) {
  return request({
    url: "/grade/delete",
    method: "post",
    params: { ...data },
  });
}



//年级列表
export function gradePage(data) {
  return request({
    url: "/grade/page",
    method: "post",
    data,
  });
}


// 年级新增/编辑
export function gradeAddOrEdit(data) {
  return request({
    url: "/grade/addOrEdit",
    method: "post",
    data,
  });
}

/***** minica 杭州博乐 admin add end ****/

